import { API, setAuthToken } from '../../../config/API.js';
import { GET_CSR, SET_LOADING_CSR, SET_PAGINATION_CSR } from '../constant.js';

export const getDataCSR = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_CSR,
      payload: true,
    });
    API.get(`admin/news/csr?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_CSR,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_CSR,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_CSR,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_CSR,
          payload: 0,
        });
      });
  };
};

export const addDataCSR = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/news/csr/add", params);
};

export const getDetailDataCSR = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/news/csr/${code}`);
};

export const updDataCSR = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/news/csr/edit", params);
};

export const delDataCSR = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/news/csr/delete/" + code);
};
